import { CheckCircle2 } from 'lucide-react';

const deliverables = [
  'Score por dimensões da operação (Produto, Tech, Agile e Fluxo)',
  'Análise clara dos principais gargalos e riscos',
  'Próximos passos priorizados (now / next / later)',
  'Um resumo executivo fácil de compartilhar',
];

export function WhatYouReceive() {
  return (
    <section className="py-24 px-4 sm:px-8 lg:px-16" aria-labelledby="what-you-receive-heading">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 space-y-4">
          <span className="text-primary text-sm font-medium uppercase tracking-widest">
            O que você recebe
          </span>
          <h2 id="what-you-receive-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold">
            Ao final do diagnóstico, você recebe:
          </h2>
        </div>

        {/* Card */}
        <div className="bg-card border border-border rounded-xl p-8 md:p-10">
          <ul className="space-y-4">
            {deliverables.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <CheckCircle2
                  className="h-6 w-6 text-primary flex-shrink-0 mt-0.5"
                  aria-hidden="true"
                />
                <span className="text-foreground text-lg">{item}</span>
              </li>
            ))}
          </ul>

          {/* Footer note */}
          <div className="mt-8 pt-6 border-t border-border">
            <p className="text-sm text-muted-foreground">
              Tudo apresentado de forma objetiva, sem buzzwords ou jargões desnecessários.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
